import api from './api';

// Settings › AI assistant — providers and models. Admin only on every call.
// Copied from Mantle (frontend/src/services/aiConfigService.js).
//
// THE API KEY ONLY EVER TRAVELS ONE WAY. `get` returns `key_set` and
// `api_key_hint` (last four characters), never the key. `saveProvider` sends
// `api_key` ONLY when deliberately replacing it — omitting it keeps the stored key.
const aiConfigService = {
  get: () => api.get('/ai-config').then((r) => r.data),
  saveProvider: (provider) => api.put('/ai-config/provider', { provider }).then((r) => r.data),
  // A FAILED test comes back as HTTP 200 with success:false — the failure is the useful result.
  testProvider: (providerCode, modelCode) =>
    api.post('/ai-config/test', { provider_code: providerCode, model_code: modelCode || undefined }).then((r) => r.data),
  deleteProvider: (code) => api.delete(`/ai-config/provider/${encodeURIComponent(code)}`).then((r) => r.data),
  saveModel: (model) => api.put('/ai-config/model', { model }).then((r) => r.data),
  deleteModel: (providerCode, modelCode) =>
    api.delete(`/ai-config/model/${encodeURIComponent(providerCode)}/${encodeURIComponent(modelCode)}`).then((r) => r.data),
};

export default aiConfigService;
